import { Component } from '@angular/core';

@Component({
  selector: 'app-dummy',
  template: '<p>Redirecting...</p>',
})
export class DummyComponent {}
